import axios from '@axios';
import HelperService from './HelperService';

const helperService = new HelperService();

const baseApi = '/api/v1'
const base = '/api/v1/visits';
const baseBans = '/api/v1/bans';
const baseCallEvents = '/api/v1/call-events';
const baseStats = '/api/v1/visit-call-stats';

export default {
  getPrisonStats() {
    return axios.get(`${base}/prison/stats?isInCellCall=false`);
  },
  getVisits(filters) {
    const defaultFilters = { ...filters, visitType: 'standard' };
    const queryString = helperService.buildSearchQueryString(defaultFilters);
    return axios.get(`${base}/prison/paginated${queryString}`);
  },
  getRejectedVisits() {
    return axios.get(`${base}/prison?status=Rejected&visitType=standard`);
  },
  getApprovedVisits() {
    return axios.get(`${base}/prison?status=Approved&visitType=standard`);
  },
  getSingleVisit(visitId) {
    return axios.get(`${base}/single-visit/${visitId}`);
  },
  getNumberOfVisitsThisMonth(prisonerNumber, startDate) {
    return axios.get(`${base}/num-of-visits/${prisonerNumber}/${startDate}`);
  },
  cancelVisit(visitId, reason) {
    return axios.post(`${base}/cancel/${visitId}`, reason);
  },
  rejectVisit(visitId, reason) {
    return axios.post(`${base}/reject/${visitId}`, reason);
  },
  approveVisit(visitId, details) {
    return axios.post(`${base}/approve-and-fund/${visitId}`, details);
  },
  approveVisitFunded(visitId, details, funded = false) {
    if (funded) {
      return axios.post(`${base}/approve-and-fund/${visitId}`, details);
    }
    return axios.post(`${base}/approve/${visitId}`, details);
  },
  getVisitorsBan(visitorUserId) {
    return axios.get(`${baseBans}/user/${visitorUserId}`);
  },
  bookVisit(requestData) {
    return axios.post(`${base}/book-visit`, requestData);
  },
  generateRecording(visitId) {
    return axios.post(`${base}/recording/generate/${visitId}`);
  },
  getRecordingsAndDownloadLink(visitId, otp) {
    return axios.get(`${baseApi}/recordings/for-visit/${visitId}/${otp}/recordings-and-download-link`);
  },
  createDownloadRecordingEvent(visitId) {
    return axios.get(`${baseApi}/recording-access-audit-log/download-access/${visitId}`);
  },
  // getRecordingsAndDownloadLink(){
  //   return axios.get(`http://localhost:3000/recordings`);
  // },
  getCallEvents(visitId, otp, skip, perPage) {
    return axios.get(`${baseCallEvents}/for-visit-paginated/all/${visitId}/${otp}?skip=${skip}&limit=${perPage}`);
  },
  getVisitStats(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${baseStats}/${queryString}`);
  },
  getVisitBookedAndCompletedStats(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/stats/booked-and-completed${queryString}`);
  },
  getVisitBusiestDayOfWeek(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/stats/busiest-day-of-week${queryString}`);
  },
  getVisitCancellationReasonStats(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/stats/cancellation-reasons${queryString}`);
  },
  getVisitStatsAveragePauses(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${baseStats}/stats/average-pauses${queryString}`);
  },
  getBookingSlotUsageStats(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/stats/booking-slots-usage${queryString}`);
  },
  updateExternalCancellation(visitId, cancellationValue) {
    return axios.post(`${base}/external-cancellation/${visitId}`, { external_cancellation: cancellationValue });
  },
  bookOffsiteVisit(requestData) {
    return axios.post(`${base}/book-offsite-visit`, requestData);
  },
  bookIntakeVisit(requestData) {
    return axios.post(`${base}/book-intake-visit`, requestData);
  },
  getVisitorsVisits(visitorId) {
    return axios.get(`${base}/user/${visitorId}`);
  },
  getVisitorsPreviousVisits(visitorId) {
    return axios.get(`${base}/visitor-user/${visitorId}/previous-visits`);
  },
  refundKioskItems(visitId, dto) {
    return axios.post(`${base}/refund-kiosk-items/${visitId}`, dto);
  },
  purpleScribeGenerate(visitId) {
    return axios.post(`${base}/purple-scribe/generate/${visitId}`);
  },
};
